import React, { useState, useEffect } from "react";

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(50); // start at 50 seconds
  const [isRunning, setIsRunning] = useState(true); // control timer

  useEffect(() => {
    if (!isRunning) return; // pause if stopped

    if (timeLeft === 0) {
      setIsRunning(false); // stop at 0
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    // Cleanup to prevent multiple timers
    return () => clearTimeout(timer);
  }, [timeLeft, isRunning]);

  const handleSubmit = () => {
    setIsRunning(false);
    alert("Submitted with " + timeLeft + " seconds left!");
  };

  return (
    <div style={{ marginTop: "40px" }}>
      <h1>{timeLeft > 0 ? `Time Left: ${timeLeft}s` : "Time's left!"}</h1>
      <button
        onClick={handleSubmit}
        disabled={!isRunning}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: isRunning ? "pointer" : "not-allowed",
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default CountdownTimer;
